import { render, staticRenderFns } from "./ShapeLayer.vue?vue&type=template&id=21b483fc"
import script from "./ShapeLayer.vue?vue&type=script&lang=js"
export * from "./ShapeLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21b483fc')) {
      api.createRecord('21b483fc', component.options)
    } else {
      api.reload('21b483fc', component.options)
    }
    module.hot.accept("./ShapeLayer.vue?vue&type=template&id=21b483fc", function () {
      api.rerender('21b483fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/psd-layers/layer-views/ShapeLayer.vue"
export default component.exports